"use strict"

import {observable, action} from "mobx"

class ConsentDialogStore {
	@observable isOpen = false

	formRef = null

	@action open() {
		this.isOpen = true
	}

	@action close(form) {
		this.isOpen = false
		form.$("consent").value = false
	}
}

var singleton = new ConsentDialogStore()
export default singleton

